import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBigBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.7222 13.5472L17 11.4083L21.2778 13.5472V3.55553H12.7222V13.5472ZM7.83333 26.1667V22.5H17V26.1667H7.83333ZM3.55553 33.5C2.73053 33.5 2.01502 33.197 1.40901 32.591C0.803004 31.985 0.5 31.2695 0.5 30.4445V3.55553C0.5 2.73053 0.803004 2.01502 1.40901 1.40901C2.01502 0.803005 2.73053 0.5 3.55553 0.5H30.4445C31.2695 0.5 31.985 0.803005 32.591 1.40901C33.197 2.01502 33.5 2.73053 33.5 3.55553V30.4445C33.5 31.2695 33.197 31.985 32.591 32.591C31.985 33.197 31.2695 33.5 30.4445 33.5H3.55553ZM3.55553 30.4445H30.4445V3.55553H24.3333V18.4972L17 14.8305L9.66667 18.4972V3.55553H3.55553V30.4445Z",
		fill: "#393A36"
	})
});
export default SvgBigBox;
